/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerFieldHistoryRequest } from '../../models/customer-field-history-request';
import { CustomerFieldHistoryResponse } from '../../models/customer-field-history-response';

export interface PostApiCustomerV1IdHistory$Json$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: CustomerFieldHistoryRequest
}

export function postApiCustomerV1IdHistory$Json(http: HttpClient, rootUrl: string, params: PostApiCustomerV1IdHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerFieldHistoryResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1IdHistory$Json.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerFieldHistoryResponse>;
    })
  );
}

postApiCustomerV1IdHistory$Json.PATH = '/private/v1/customers/{id}/history';
